import axios from 'axios';
import { CONFIG } from '@/config/Config';
import { addSessionId } from '@/core/utils/httpHeaders';
import { LocationItem, LocationsParams, LocationsResponse } from './interfaces/LocationInterfaces';

const SERVICE_NAME = 'locations-service';
const EMPTY_LOCATIONS: LocationsResponse = { locations: [] };

class LocationsService {
  async getLocations(params: Partial<LocationsParams> = {}): Promise<LocationsResponse> {
    const searchTerm = params.location?.trim();

    if (!searchTerm) return EMPTY_LOCATIONS;

    const baseUrl = CONFIG.getServiceUrl(SERVICE_NAME);
    const url = `${baseUrl}/v2/locations/find`;
    const headers = addSessionId({ accept: 'application/json' });

    try {
      const response = await axios.get<LocationItem[]>(url, {
        headers,
        params: { location: searchTerm },
      });

      return { locations: response.data ?? [] };
    } catch (error) {
      console.error('error:', error);
      return EMPTY_LOCATIONS;
    }
  }
}

const locationsService = new LocationsService();
export default locationsService;